import * as React from 'react'
import styled from 'styled-components'
import Modal, { IFModalProps } from '@app.components/Modal/Modal'
import SearchMobileHeader from '../component/SearchMobileHeader'
import HotKeywordList from './HotKeywordBoxList'

// todo :header에서 input 관리하도록 로직 개선

type IFScreenChannelSearchModalProps = IFModalProps

const ScreenChannelSearchModal: React.FC<IFScreenChannelSearchModalProps> = ({
  onClose,
  ...props
}) => {
  return (
    <Modal onClose={onClose} {...props} animation="left">
      <StyledWrapper>
        <SearchMobileHeader title="채널 검색" onClose={onClose} />
        <div className="list-box">
          <HotKeywordList />
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default ScreenChannelSearchModal

const StyledWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: white;
  .list-box {
    padding-top: 108px;
  }
`
